
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useMemo, useState } from "react";
import { TOpcoesVisualizacao, coresTabelas, mostrarDadoPrimario } from "../../../..";
import { formatarValorMonetario } from "../../../../../../helpers/masks";
import moment, { Moment } from "moment";
import { useQuery } from "react-query";
import axiosClient from "../../../../../../lib/axios";
import { IDataResumoTitulosPagar } from "../../../../../../types/api/financeiro/resumo-titulos-pagar";
import LoadingApiQuery from "../../../../../../components/LoadingApiQuery";
import { TPreFilters } from "../Listagem";

export default function TableTitulosPagar({
    handleChangePreFilters,
    preVisualizacao = "Por público"
}: TableTitulosPagarProps) {

    const [visualizacao, setVisualizacao] = useState<TOpcoesVisualizacao>(preVisualizacao)

    const opcoesVisualizacao: TOpcoesVisualizacao[] = [
        "Por público",
        "Por departamento"
    ]

    //query
    const { data: resultTitulosPagar, isLoading: isLoadingTitulosPagar } = useQuery({
        queryKey: ["resumo-titulos-pagar", visualizacao],
        queryFn: () => axiosClient.get("financeiro/contas-pagar/resumo-titulos-pagar", {
            params: {
                visualizacao
            }
        })
    });
    const { dataTitulosPagar }: ITitulosPagar = {
        dataTitulosPagar: resultTitulosPagar?.data || []
    }
    //

    //funções manipuladoras
    const handleChange = (event: SelectChangeEvent) => {
        setVisualizacao(event.target.value as TOpcoesVisualizacao);
    };

    const handleRedirectCell = (dataInicial: Moment, dataFinal: Moment, dadoPrimario: string) => {
        const param: any = {
            data_vencimento_inicio: dataInicial,
            data_vencimento_fim: dataFinal
        }

        if (visualizacao === "Por público") param.tipo_publico_pesquisar = dadoPrimario.charAt(0)
        if (visualizacao === "Por departamento") param.nome_departamento_pesquisar = dadoPrimario
        handleChangePreFilters(param)
    }
    //

    //valores importantes
    const tableHead = useMemo(() => {
        const semPrefix = visualizacao.replace("Por ", '').trim()
        return semPrefix.charAt(0).toUpperCase() + semPrefix.slice(1)
    }, [visualizacao])

    const {
        totalVenceAmanha,
        totalVenceDaqui7,
        totalVenceDaqui15,
        totalVenceHoje,
        totalVenceMais30,
        totalVencidoAteOntem
    } = useMemo(() => {
        const totais = {
            totalVenceAmanha: 0,
            totalVenceDaqui7: 0,
            totalVenceDaqui15: 0,
            totalVenceHoje: 0,
            totalVenceMais30: 0,
            totalVencidoAteOntem: 0
        };

        dataTitulosPagar.forEach(item => {
            totais.totalVenceAmanha += parseFloat(item.vence_amanha);
            totais.totalVenceDaqui7 += parseFloat(item.vence_daqui_7);
            totais.totalVenceDaqui15 += parseFloat(item.vence_daqui_15);
            totais.totalVenceHoje += parseFloat(item.vence_hoje);
            totais.totalVenceMais30 += parseFloat(item.vence_mais_que_30);
            totais.totalVencidoAteOntem += parseFloat(item.vencido_ate_ontem);
        });

        return totais;
    }, [dataTitulosPagar])
    //

    return (
        <Box minWidth={1080}>
            <Box p={2} mb={2} display="flex" alignItems="flex-start" justifyContent="space-between">
                <Typography variant='h6'>Titulos a pagar</Typography>

                <FormControl sx={{ width: 180 }}>
                    <InputLabel id="select-visualizacao-receber">Visualização</InputLabel>
                    <Select
                        labelId="select-visualizacao-receber"
                        value={visualizacao}
                        label="Visualização"
                        onChange={handleChange}
                    >
                        {
                            opcoesVisualizacao.map((opcao, index) => (
                                <MenuItem key={index} value={opcao}>{opcao}</MenuItem>
                            ))
                        }
                    </Select>
                </FormControl>
            </Box>
            {
                isLoadingTitulosPagar &&
                <LoadingApiQuery />
            }

            {
                !isLoadingTitulosPagar &&
                <TableContainer>
                    <Table size="small" sx={{ minWidth: 400, overflow: "auto" }}>
                        <TableHead sx={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 100 }}>
                            <TableRow>
                                <TableCell rowSpan={2} sx={{ fontWeight: 'bold' }}>{tableHead}</TableCell>

                                <TableCell align="right" sx={{ fontWeight: 'bold', border: 0 }}>Vencidos</TableCell>
                                <TableCell align="right" sx={{ fontWeight: 'bold', border: 0 }}>Vence Hoje</TableCell>
                                <TableCell align="right" sx={{ fontWeight: 'bold', border: 0 }}>Vence amanhã</TableCell>

                                <TableCell align="right" colSpan={4} sx={{ fontWeight: 'bold', border: 0, bgcolor: coresTabelas.paraVencer }}>Para pagar</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align="right"><Typography variant="caption">Até {moment().subtract(1, "day").format("DD/MM/YYYY")}</Typography></TableCell>
                                <TableCell align="right"><Typography variant="caption">{moment().format("DD/MM/YYYY")}</Typography></TableCell>
                                <TableCell align="right"><Typography variant="caption">{moment().add(1, "day").format("DD/MM/YYYY")}</Typography></TableCell>

                                <TableCell align="right" sx={{ bgcolor: coresTabelas.paraVencer }}><Typography variant="caption">Daqui 7 dias</Typography></TableCell>
                                <TableCell align="right" sx={{ bgcolor: coresTabelas.paraVencer }}><Typography variant="caption">Daqui 15 dias</Typography></TableCell>
                                <TableCell align="right" sx={{ bgcolor: coresTabelas.paraVencer }}><Typography variant="caption">Daqui 30 dias</Typography></TableCell>
                                <TableCell align="right" sx={{ bgcolor: coresTabelas.paraVencer }}><Typography variant="caption">Mais que 30 dias</Typography></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                dataTitulosPagar.map((titulo, index) => {
                                    return (
                                        <TableRow
                                            key={index}
                                            sx={{
                                                cursor: "pointer",
                                                transition: 'background-color 0.2s ease',
                                                "&:hover": {
                                                    backgroundColor: 'rgba(255,244,229,1)'
                                                }
                                            }}
                                        >
                                            <TableCell >
                                                {mostrarDadoPrimario(titulo, visualizacao)}
                                            </TableCell>

                                            <TableCell
                                                align="right"
                                                onClick={() => {
                                                    handleRedirectCell(
                                                        moment().subtract(1, 'days'),
                                                        moment(),
                                                        mostrarDadoPrimario(titulo, visualizacao)
                                                    )
                                                }}
                                                sx={{
                                                    transition: 'background-color 0.2s ease',
                                                    "&:hover": {
                                                        backgroundColor: 'rgba(0,0,0,0.1)'
                                                    }
                                                }}
                                            >
                                                {formatarValorMonetario(Number(titulo.vencido_ate_ontem))}
                                            </TableCell>

                                            <TableCell
                                                align="right"
                                                onClick={() => {
                                                    handleRedirectCell(
                                                        moment(),
                                                        moment(),
                                                        mostrarDadoPrimario(titulo, visualizacao)
                                                    )
                                                }}
                                                sx={{
                                                    transition: 'background-color 0.2s ease',
                                                    "&:hover": {
                                                        backgroundColor: 'rgba(0,0,0,0.1)'
                                                    }
                                                }}
                                            >
                                                {formatarValorMonetario(Number(titulo.vence_hoje))}
                                            </TableCell>

                                            <TableCell
                                                align="right"
                                                onClick={() => {
                                                    handleRedirectCell(
                                                        moment(),
                                                        moment().add(1, 'days'),
                                                        mostrarDadoPrimario(titulo, visualizacao)
                                                    )
                                                }}
                                                sx={{
                                                    transition: 'background-color 0.2s ease',
                                                    "&:hover": {
                                                        backgroundColor: 'rgba(0,0,0,0.1)'
                                                    }
                                                }}
                                            >
                                                {formatarValorMonetario(Number(titulo.vence_amanha))}
                                            </TableCell>

                                            <TableCell
                                                align="right"
                                                onClick={() => {
                                                    handleRedirectCell(
                                                        moment(),
                                                        moment().add(7, 'days'),
                                                        mostrarDadoPrimario(titulo, visualizacao)
                                                    )
                                                }}
                                                sx={{
                                                    bgcolor: coresTabelas.paraVencer,
                                                    transition: 'background-color 0.2s ease',
                                                    "&:hover": {
                                                        backgroundColor: 'rgba(0,0,0,0.1)'
                                                    }
                                                }}
                                            >
                                                {formatarValorMonetario(Number(titulo.vence_daqui_7))}
                                            </TableCell>

                                            <TableCell
                                                align="right"
                                                onClick={() => {
                                                    handleRedirectCell(
                                                        moment(),
                                                        moment().add(15, 'days'),
                                                        mostrarDadoPrimario(titulo, visualizacao)
                                                    )
                                                }}
                                                sx={{
                                                    bgcolor: coresTabelas.paraVencer,
                                                    transition: 'background-color 0.2s ease',
                                                    "&:hover": {
                                                        backgroundColor: 'rgba(0,0,0,0.1)'
                                                    }
                                                }}
                                            >
                                                {formatarValorMonetario(Number(titulo.vence_daqui_15))}
                                            </TableCell>

                                            <TableCell
                                                align="right"
                                                onClick={() => {
                                                    handleRedirectCell(
                                                        moment(),
                                                        moment().add(30, 'days'),
                                                        mostrarDadoPrimario(titulo, visualizacao)
                                                    )
                                                }}
                                                sx={{
                                                    bgcolor: coresTabelas.paraVencer,
                                                    transition: 'background-color 0.2s ease',
                                                    "&:hover": {
                                                        backgroundColor: 'rgba(0,0,0,0.1)'
                                                    }
                                                }}
                                            >
                                                {formatarValorMonetario(Number(titulo.vence_mais_que_30))}
                                            </TableCell>

                                            <TableCell
                                                align="right"
                                                onClick={() => {
                                                    handleRedirectCell(
                                                        moment(),
                                                        moment().add(90, 'days'),
                                                        mostrarDadoPrimario(titulo, visualizacao)
                                                    )
                                                }}
                                                sx={{
                                                    bgcolor: coresTabelas.paraVencer,
                                                    transition: 'background-color 0.2s ease',
                                                    "&:hover": {
                                                        backgroundColor: 'rgba(0,0,0,0.1)'
                                                    }
                                                }}
                                            >
                                                {formatarValorMonetario(Number(titulo.vence_mais_que_30))}
                                            </TableCell>
                                        </TableRow>
                                    )
                                })
                            }

                            <TableRow>
                                <TableCell />

                                <TableCell
                                    align="right"
                                    sx={{ fontWeight: "bold", }}
                                >
                                    {formatarValorMonetario(totalVencidoAteOntem)}
                                </TableCell>

                                <TableCell
                                    align="right"
                                    sx={{ fontWeight: "bold", }}
                                >
                                    {formatarValorMonetario(totalVenceHoje)}
                                </TableCell>

                                <TableCell
                                    align="right"
                                    sx={{ fontWeight: "bold", }}
                                >
                                    {formatarValorMonetario(totalVenceAmanha)}
                                </TableCell>

                                <TableCell
                                    align="right"
                                    sx={{
                                        fontWeight: "bold",
                                        bgcolor: coresTabelas.paraVencer
                                    }}
                                >
                                    {formatarValorMonetario(totalVenceDaqui7)}
                                </TableCell>

                                <TableCell
                                    align="right"
                                    sx={{
                                        fontWeight: "bold",
                                        bgcolor: coresTabelas.paraVencer
                                    }}
                                >
                                    {formatarValorMonetario(totalVenceDaqui15)}
                                </TableCell>

                                <TableCell
                                    align="right"
                                    sx={{
                                        fontWeight: "bold",
                                        bgcolor: coresTabelas.paraVencer
                                    }}
                                >
                                    {formatarValorMonetario(totalVenceMais30)}
                                </TableCell>

                                <TableCell
                                    align="right"
                                    sx={{
                                        fontWeight: "bold",
                                        bgcolor: coresTabelas.paraVencer
                                    }}
                                >
                                    {formatarValorMonetario(totalVenceMais30)}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            }
        </Box>
    )
}

interface TableTitulosPagarProps {
    handleChangePreFilters: (value: TPreFilters) => void
    preVisualizacao?: TOpcoesVisualizacao,
}

interface ITitulosPagar {
    dataTitulosPagar: IDataResumoTitulosPagar[]
}